import { useTranslation } from "react-i18next";

import { usePermanentRealtimeDealers } from "components/DealersAndLocationsDropdown/hooks";

export const useEntityNames = () => {
  const { t } = useTranslation();

  const { dealers } = usePermanentRealtimeDealers();

  const matchDealersAndLocations = (dealerIds: number[] | null, locationIds: number[] | null) => {
    const matchingDealers = dealers.filter(dealer => dealerIds?.includes(dealer.id) || dealer.locations?.some(location => locationIds?.includes(location.id)));

    const computedValue = matchingDealers.map(dealer => {
      if (dealerIds?.includes(dealer.id)) return `${dealer.name}: ${t("v8_all_locations", "All locations")}; `;

      const matchingLocations = dealer.locations?.filter(location => locationIds?.includes(location.id)).map(loc => loc.name);

      if (!matchingLocations?.length) return "";
      if (matchingLocations.length === 1 && matchingDealers.length > 1) return `${dealer.name}: ${matchingLocations.at(0)};  `;

      return `${dealer.name}: ${matchingLocations.join("; ")}`;
    });

    if (computedValue.length > 0) computedValue[computedValue.length - 1] = computedValue[computedValue.length - 1].trimEnd().replace(/;$/, "");

    return computedValue;
  };

  return { matchDealersAndLocations };
};
